// const sourceFields = require('../../../config/sourceFields.json');
const esFields = require('../../../config/esFields.json');
let sourceFields = {};
Object.keys(esFields).forEach((key)=>{
  // note that fields with no label will be hidden in the 'detailed metadata' UI -- todo: use 'display' param instead
  sourceFields[key] = esFields[key].label
})

const fields = {
  sourceFields: sourceFields,

  // facet objects
  // type 'term' for text facets, 'range' for dates or numeric ranges  // todo use esFields for this too.
  // facets will be displayed in this order.
  facetFields : [
    {
      field: 'mediaType',
      label: 'Media type',
      type: 'term'
    },
    {
      field: 'sortDate',
      label: 'Date range',
      type: 'range',
      date_format: 'yyyy',
      interval: 'year'
    },
    {
      field: 'creator',
      label: 'Creator',
      type: 'term'
    },
    {
      field: 'genre',
      label: 'Genre',
      type: 'term'
    },
    {
      field: 'subject',
      label: 'Subject',
      type: 'term'
    },
    {
      field: 'language',
      label: 'Language',
      type: 'term'
    },
  ],
}

const searchOpts = {
  defaultIndex: "chungapp",
  queryPrompt: "Enter a query to search the Chung Collection.",
  facetLimitLabel: "Limit by:",
  searchScope: [  // options in the 'search scope' dropdown - values must be valid ElasticSearch indices
    {
      value: "chungapp",
      label: "Search All Content"
    },
    {
      value: "chungapp.atm*",
      label: "Search Digitized Content"
    },
    {
      value: "chungapp.*",
      label: "Search Physical Collection"
    }
  ],
  sortResults: [
    {
      value: "_score",
      label: "Sort by Relevance"
    },
    {
      value: "title.sort,asc",
      label: "Sort by Title A-Z"
    },
    {
      value: "title.sort,desc",
      label: "Sort by Title Z-A"
    },
    {
      value: "sortDate,asc",
      label: "Sort oldest to newest"
    },
    {
      value: "sortDate,desc",
      label: "Sort newest to oldest"
    }
  ],
  pageSizes: [20, 40, 80],
  facetSize: 10
}

export { fields, searchOpts };
